<template>
  <div class="shop-profile no-scrollbar" :key="z">
    <TukLoader
      v-if="showTukLoader"
      @check="checkTukLoader()"
      @hide="showTukLoader = false"
    />

    <div v-if="business">
      <div :class="{ 'hide-top': showDesktopCover }">
        <div v-if="isWhiteLabel">
          <a
            class="button is-white is-rounded white-label"
            @click="gotoWhiteLabelHome"
          >
            <span class="icon">
              <i class="fa fa-home" />
            </span>
          </a>
        </div>
        <div v-else>
          <MainBackButton />
        </div>

        <div class="hidden-top-left-btn" @click="viewBanner" />

        <div v-if="!isExpress" class="top-right">
          <span
            v-if="tab === 'promos'"
            class="icon shadow toggle-view"
            :class="{ 'toggle-right': minimalMode }"
            @click="toggleView"
          >
            <i v-if="menuView === 'list'" class="fa fa-th-large fa-lg" />
            <i v-else class="fa fa-bars fa-lg" />
          </span>
          <!-- <span :class="{ 'is-hidden': minimalMode }"> -->
          <span v-if="!minimalMode" style="margin-right: 20px">
            <!-- <span :class="{ 'toggle-down-right': minimalMode }"> -->
            <span
              class="icon has-text-danger shadow"
              style="margin-right: 20px"
              @click="favoriteShop"
            >
              <i v-if="isFavorite(business.id)" class="fa fa-heart fa-lg" />
              <i v-else class="far fa-heart fa-lg" style="color: pink" />
            </span>
            <span class="icon" @click="shareShop">
              <img src="/img/home2/share_white.svg" class="shadow share" />
            </span>
          </span>

          <div v-if="minimalMode" class="share-right">
            <span class="icon" @click="shareShop">
              <img src="/img/home2/share_white.svg" class="shadow share" />
            </span>
          </div>

          <!-- <div
            :class="openClosed.class"
            class="open-closed"
            @click="triggerShowHours"
          >
            <span v-if="minimalMode"><i class="far fa-clock" /></span>
            <span v-else>{{ openClosed.text }}</span>
          </div> -->
          <div
            v-if="!(isOpen && minimalMode)"
            :class="openClosed.class"
            class="open-closed"
            @click="triggerShowHours"
          >
            {{ openClosed.text }}
          </div>
        </div>

        <!-- <div v-if="desktopBannerPicURL && !shorten">
        <div class="desktop" v-webp:bg="desktopBannerPicURL" />
      </div> -->
        <div class="hero-wrapper" :style="themeBgColor">
          <section
            class="hero has-bg-img"
            :class="{
              'hero-short': heroShort,
              tile: isTile,
            }"
            v-webp:bg="bannerPicURL"
          >
            <div class="hero-body" style="padding: 0"></div>
            <div class="gradient">
              <div class="hero-foot has-text-left has-text-white subtitle">
                <p
                  ref="shopName"
                  class="shop-name has-text-weight-bold shadow"
                  :class="{ 'not-short': !shorten && tab === 'promos' }"
                  @click="gotoBusinessProfile"
                >
                  <span
                    v-if="business.is_deleted"
                    class="has-text-danger"
                    style="margin-right: 5px"
                    >DELETED</span
                  >{{ businessName }}
                </p>
                <p
                  v-if="tab !== 'promos'"
                  class="shadow single-line no-scrollbar categories"
                >
                  {{ categoryList }}
                </p>
                <!-- <p v-else-if="!shorten" style="height: 30px" /> -->

                <!-- :class="{ 'tab-short': tab === 'promos' }" -->
                <span
                  v-if="!isExpress"
                  class="tab-name"
                  :class="{ 'tab-short': shorten }"
                  :style="themeColor"
                  @click="changeTab"
                >
                  <span class="link">
                    <span v-if="tab === 'info'">{{ $t("shop.menu") }}</span>
                    <span v-else>{{ $t("shop.info") }}</span>
                  </span>
                  <i class="fa fa-angle-right" style="margin-left: 4px" />
                </span>

                <img v-img class="banner" :src="bannerPicURL" />
              </div>
            </div>

            <fade-transition :duration="800">
              <div
                v-show="showHours"
                class="hours-wrapper"
                :class="hoursClass"
                @click="showHours = false"
              >
                <p v-html="todaysHoursHTML" />
              </div>
            </fade-transition>
          </section>
        </div>

        <img
          v-if="!isExpress"
          class="profile-pic"
          :class="profilePicClass"
          :src="profilePicURL"
          @click="gotoCommerceHome"
        />
      </div>

      <div style="margin-top: -1px">
        <ShopInfoTab
          v-if="tab === 'info'"
          ref="info"
          :key="'info' + id"
          :isWhiteLabel="isWhiteLabel"
          @brandStory="brandStory"
          @scrollTop="infoTabScrolled"
          @touchmove="scrollTop = 1"
          @touchend="infoTabScrolled"
        />
        <ShopPromosTab
          v-show="tab === 'promos'"
          ref="menu"
          :key="'menu' + id"
          :tableNumber="tableNumber"
          :deliveryWorkflows="deliveryWorkflows"
          :view="menuView"
          :instagram="instagram"
          :search="search"
          @scrolled="shorten = true"
          @shopWhenOpen="triggerShopWhenOpen"
          @gotoInfoTab="setTab('info')"
          @reactivateShopProfile="reactivate()"
        />
      </div>

      <div v-if="showInactive" class="deleted-bg" @click="showInactive = false">
        <div v-if="business.is_deleted" class="band-aid">
          <i>{{ $t("Archived Business") }}</i>
        </div>

        <div v-if="isBlocked" class="band-aid red">
          <i>{{ $t("Currently Unavailable") }}</i>
        </div>

        <!-- <div v-if="!business.is_active && showInactiveBtn" class="inactive-btn">
          {{ $t("Test Order Only") }}
          <p style="font-size: 0.6em">
            Shop is still being set up
            <i class="fa fa-umbrella-beach has-text-primary" style="text-shadow: 0 0 1px black" />
          </p>
        </div> -->

        <div v-else-if="!isOpen" class="band-aid red">
          {{ $t("Currently Closed") }}
          <p style="font-size: 0.6em">
            {{ $t("shop.todays-hours") }}: {{ todaysHours }}
          </p>
        </div>

        <div v-else-if="isPaused" class="band-aid yellow">
          {{ $t("Temporarily Paused") }}
          <p style="font-size: 0.6em">
            Please check back in 15 minutes
            <i class="fa fa-hourglass-half" />
          </p>
        </div>
      </div>

      <fade-transition>
        <ShopProfileDesktopCover
          v-if="showDesktopCover"
          @gotoTab="setTab"
          @close="
            hideDesktopCover = true;
            showBrandStory = false;
          "
        />
      </fade-transition>
    </div>

    <!-- I think this is deprecated? -->
    <div v-else>
      <div class="tuk-icon centered"></div>
      <div class="loading" :class="$store.state.theme">
        <div v-if="isLoading" class="centered">
          <HalfCircleSpinner
            :animation-duration="1200"
            :size="190"
            color="#209CEE"
          />
        </div>
        <div v-else style="padding-top: 50px">
          <i
            class="fa fa-kiwi-bird fa-4x has-text-white wiggle"
            style="padding-bottom: 20px; filter: drop-shadow(0 0 4px grey)"
            @click="refreshPage"
          />
          <p class="title has-text-grey">{{ $t("business-not-found") }}</p>
          <span class="button is-success" @click="goHome">
            {{ $t("go-home") }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import EventBus from "../eventBus";
import ShopInfoTab from "@/components/ShopInfoTab";
import ShopPromosTab from "@/components/ShopPromosTab";
import ShopProfileDesktopCover from "@/components/ShopProfileDesktopCover";
import MainBackButton from "@/components/MainBackButton";
import TukLoader from "@/components/TukLoader";
import { HalfCircleSpinner } from "epic-spinners";

export default {
  name: "ShopProfile",
  components: {
    MainBackButton,
    ShopInfoTab,
    ShopPromosTab,
    TukLoader,
    ShopProfileDesktopCover,
    HalfCircleSpinner,
  },
  props: {
    id: String,
  },
  // metaInfo() {
  //   return {
  //     title: this.business.name,
  //     meta: [
  //       { name: "description", content: "description " + this.menuView },
  //       { property: "og:title", content: "name of shop" }, //this.userData.name + " - Epiloge" },
  //       { property: "og:site_name", content: "Epiloge" },
  //       { property: "og:description", content: "something" },
  //       { property: "og:type", content: "profile" },
  //       { property: "og:url", content: "https://google.com" },
  //       { property: "og:image", content: "https://picsum.photos/200/300" },
  //     ],
  //   };
  // },
  data() {
    return {
      search: null, // set from url param
      businessID: null,
      tab: "promos", // start on info tab or promos tab if has commerce workflow
      isLoading: true,
      hideDesktopCover: false,
      showBrandStory: false,

      // size: window.innerWidth * 0.75,
      showHours: false,
      todaysHoursHTML: null,
      tableNumber: null,
      checkMart: false,
      showTukLoader: false,
      isWhiteLabel: false,
      showInactive: false, // set after loading business/commerce
      deliveryWorkflows: null,
      query: null, // save url query
      menuView: "list", // or "grid"
      instagram: false,
      shorten: false, // set to true on promos tab after interaction
      scrollTop: 0, // info tab scroll position
      width: 0, // set based on window width
      // shopID: null, // set from route path
      z: 0,
    };
  },
  watch: {
    id() {
      this.activated(); // changed shop!
      this.$nextTick(() => this.setTab(this.tab)); // set the tab again to force the basket
    },
  },
  computed: {
    isExpress() {
      return this.$route.path.startsWith("/express/");
    },
    userDeliveryOptions() {
      var user = this.$store.state.user;
      if (!user || !user.data.delivery_options) return null;
      return user.data.delivery_options;
    },
    businessName() {
      var name = this.business.name;
      // if (this.business.is_deleted) name = "DELETED - " + name;
      return this.shortenString(name, 80);
    },
    showDesktopCover() {
      if (this.showBrandStory) return true;
      if (this.width < 770 || this.hideDesktopCover) return false;
      return this.desktopBannerPicURL;
    },
    themeBgColor() {
      var bgColor = this.business.data.theme_color;
      if (!bgColor) return null;
      return `background-color: ${bgColor}`;
    },
    themeColor() {
      if (this.width < 770) return null; // use default white text
      var bgColor = this.business.data.theme_color;
      if (!bgColor) return null;
      return `color: ${this.$h.textColor(bgColor)}`;
    },
    // scroll0() {
    //   return this.scrollTop;
    // },
    minimalMode() {
      return this.tab === "promos" && this.shorten && this.width < 1080;
    },
    profilePicClass() {
      if (this.shorten && this.width < 850) return "pp-hidden";
      if (this.tab === "promos") return "pp-medium";
      if (this.scrollTop > 0) return "pp-high";
      return null;
    },
    isTile() {
      return this.business.data.banner_style === "tile";
    },
    heroShort() {
      return this.tab === "promos" && this.shorten;
    },
    superuser() {
      return this.$store.getters.isSuperUser;
    },
    business() {
      return this.$store.state.selectedBusiness;
    },
    data() {
      if (!this.business) return {};
      return this.business.data;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    homeTab() {
      if (!this.commerce) return "info";
      return this.commerce.data.home_tab || "menu";
    },
    businessType() {
      if (!this.business) return null;
      var cat = this.business.business_type;
      // if (!this.$store.getters.isShops) {
      if (cat === "Service") {
        if (this.business.data.categories) {
          cat = this.business.data.categories.split(",")[0]; // return first category for service
        }
      }
      return this.translateCategory(cat);
    },
    desktopBannerPicURL() {
      return this.business.data.desktop_banner_pic_url;
    },
    bannerPicURL() {
      if (this.business.banner_pic_url) return this.business.banner_pic_url;
      return `https://www.khaosodenglish.com/wp-content/uploads/2019/02/DSC06061.jpg`;
    },
    profilePicURL() {
      return (
        this.business.profile_pic_url ||
        this.$store.state.menuItemPlaceholderPic
      );
    },
    closedUntil() {
      if (!this.commerce || !this.commerce.data.closed_until) return null;
      return this.isFutureTime(this.commerce.data.closed_until);
    },
    isPaused() {
      if (!this.commerce) return false;
      return this.commerce.data.paused;
    },
    isBlocked() {
      if (!this.commerce) return false;
      return this.commerce.data.blocked;
    },
    hoursClass() {
      if (this.isPaused) return "is-paused";
      if (this.isOpen) return "is-open";
      return null;
    },
    openClosed() {
      var open = { text: this.$t("shop.open"), class: "has-text-success" };
      var closed = { text: this.$t("shop.closed"), class: "has-text-danger" };
      var paused = { text: this.$t("shop.paused"), class: "has-text-warning" };
      var blocked = {
        text: this.$t("shop.unavailable"),
        class: "has-text-danger",
      };
      if (this.isPaused) return paused;
      if (this.isBlocked) return blocked;
      if (this.closedUntil) return closed;
      if (this.data.hours_type === "always-open") return open;
      if (!this.data.hours) return open; // unknown hours, say open
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" });
      var hours = this.data.hours[today.toLowerCase()];
      if (hours && this.openNow(hours)) return open;
      return closed;
    },
    isOpen() {
      if (!this.business) return false;
      if (this.isBlocked) return false;
      if (this.closedUntil) return false;
      if (this.data.hours_type === "always-open") return true;
      if (!this.data.hours) return true; // unknown hours, say open
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" });
      var hours = this.data.hours[today.toLowerCase()];
      if (hours && this.openNow(hours)) return true;
      return false;
    },
    hoursAlwaysOpen() {
      if (!this.data.hours_type) return true;
      if (this.data.hours_type === "always-open") return true;
      return false;
    },
    todaysHours() {
      if (this.isBlocked) return this.$t("shop.unavailable");
      if (this.closedUntil) return this.$t("commerce.on-holiday");
      if (this.hoursAlwaysOpen) return this.$t("always-open");
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" }); //  timeZone: "America/New_York",
      if (!this.data.hours) return this.$t("always-open");
      var hours = this.data.hours[today.toLowerCase()];
      return hours || "Closed";
    },
    categoryList() {
      var b = this.business;
      if (!b.data.categories) return b.business_type;
      var catsStr = b.data.categories;
      var arr = catsStr
        .split(",")
        .map((s) => {
          s = s.trim();
          if (!s.startsWith("_")) return s.replace(/\*/g, ""); // s.replaceAll("*", "");
        })
        .filter((s) => s);
      return arr.join(", ");
      // this.translateCategory(cat);
    },
    isSafari() {
      return (
        this.$store.getters.isSafari ||
        this.$browserDetect.isSafari ||
        this.isIOSApp()
      );
    },
    // :style="profilePicStyle"
    // profilePicStyle() {
    //   console.log("border-radius", this.scrollTop);
    //   var radius = 3 + this.scrollTop / 8;
    //   var opacity = (800 - this.scrollTop) / 800;
    //   var top = 170 - 50 * (this.scrollTop / 100);
    //   return `border-radius: ${radius}px; opacity: ${opacity}; top: ${top}px`;
    // },
  },
  beforeRouteLeave(to, from, next) {
    console.log("to", to);
    if (to.name === "orders") {
      next();
      return;
    }
    if (this.$refs.menu && this.$refs.menu.handleBackButton()) {
      // console.log("beforeRouteLeave", from, to);
      next(false);
      return; // don't leave if handled
    }
    next();
  },
  mounted() {
    this.checkLangQuery();
    this.subscribeToStore();
    EventBus.$on("GO_TO_PROMOS_TAB", () => this.setTab("promos"));
    EventBus.$on("BREAK_SHOP_CACHE", () => this.breakShopCache());
    this.activated();
  },
  beforeDestroy() {
    EventBus.$off("GO_TO_PROMOS_TAB");
    EventBus.$off("BREAK_SHOP_CACHE");
  },
  methods: {
    activated() {
      window.scrollTo(0, 0); // scroll to top

      this.width = window.innerWidth;

      this.businessID = this.$route.params.id;
      var id = this.$route.params.id; // businessID << pulling from view param now...
      this.console(`ShopProfile this.$route ${id}`, this.$route);
      this.checkBusiness(id);

      setTimeout(() => this.breakShopCache(), 3000);

      var query = this.$route.query;
      this.query = query; // for use later
      if (query.tab) this.setTab(query.tab); // otherwise uses default in data(), "info"

      if (query.tbl) this.tableNumber = query.tbl;
      if (query.table) this.tableNumber = query.table;

      if (query.menu_view) {
        if (query.menu_view === "grid") this.menuView = "grid";
        if (query.menu_view === "list") this.menuView = "list"; // default, shouldn't need this
      } else {
        if (window.innerWidth > 700) this.menuView = "grid"; // default if not set on wide screen
      }

      if (query.insta || query.instagram) {
        this.instagram = true;
        this.menuView = "grid";
      }

      var menu = this.$refs.menu; // menu tab component reference
      // console.log("$refs.menu", query.agent, menu);
      if (query.agent && menu) {
        setTimeout(() => menu.triggerAgentMode(), 100);
        setTimeout(() => menu.triggerAgentMode(), 500);
        setTimeout(() => menu.triggerAgentMode(), 900);
      }

      if (query.cat && menu) {
        setTimeout(() => menu.gotoCat(query.cat), 1200);
        setTimeout(() => menu.gotoCat(query.cat), 2500);
      }

      if (query.search && menu) {
        this.search = query.search;
        // setTimeout(() => menu.setSearchFromParent(query.search), 1000);
        // setTimeout(() => menu.setSearchFromParent(query.search), 2500); // call it twice just in case
      }

      if (query.fulfilment && menu) {
        setTimeout(() => menu.setFulfilmentType(query.fulfilment), 2000);
        setTimeout(() => menu.setFulfilmentType(query.fulfilment), 5000);
      }

      if (query.white_label) this.isWhiteLabel = true;
      else this.isWhiteLabel = false;

      if (query.promo) {
        if (query.promo.toUpperCase().startsWith("TUK")) {
          var upperPromo = query.promo.toUpperCase();
          var msg = `
          <div style='color:black'>
          Enter delivery promo code
          <span style='font-weight:550;'>${upperPromo}</span>
          <br>during checkout to unlock cashback
          <br>Spend ฿500 get ฿50 cashback!
          </div>`;
          setTimeout(() => this.$refs.menu.setPromo(upperPromo), 1000);
          setTimeout(() => this.infoToast(msg, "bottom", 15000), 5000);
        } else {
          msg = `Invalid promo code: ${query.promo}`;
          this.warningToast(msg, "bottom", 8000);
        }
      }

      if (this.$route.path !== this.$route.fullPath) {
        this.$router.replace(this.$route.path); // clear the query
      }
    },
    gotoCommerceHome() {
      if (!this.superuser) return;
      this.goto(`/commerce_home/${this.business.id}`);
    },
    brandStory() {
      this.showBrandStory = true;
    },
    infoTabScrolled(e) {
      this.scrollTop = e;
    },
    toggleView() {
      if (this.menuView === "list") this.menuView = "grid";
      else this.menuView = "list";
      this.log("toggle_menu_view", this.menuView);
      // this.$refs.menu.toggleView();
    },
    changeTab() {
      if (this.tab === "info") this.setTab("promos");
      else this.setTab("info");
    },
    gotoBusinessProfile() {
      if (!this.superuser) return;
      this.$router.push(`/business_profile/${this.business.id}`);
    },
    gotoWhiteLabelHome() {
      var url = this.business.data.website || "web.tukapp.co";
      var http = url;
      if (!http.startsWith("http")) http = "https://" + url;
      window.open(http, "_blank"); // need to add https or won't know it's an external web link
    },
    startLoadingTimer() {
      this.z += 1;
      this.isLoading = true;
      setTimeout(() => (this.isLoading = false), 8000); // if no response after 8 seconds...
    },
    subscribeToStore() {
      this.$store.subscribe((mutation) => {
        if (mutation.type === "setMarts") {
          if (!this.checkMart) return; // not checking mart
          this.checkMart = false; // only check once until triggered again
          var nearestMartID = this.$store.getters.getNearestMartID;
          if (nearestMartID === this.business.id) return; // ok
          // this.successToast("We found a closer mart", "top");
          this.goto("shop/" + nearestMartID);
          this.reactivate();
        }
      });
    },
    reactivate() {
      this.checkBusiness(this.$route.params.id); // businessID

      this.activated();
      var query = this.$route.query;
      if (query.tab) this.setTab(query.tab);
      else this.setTab("info"); // otherwise default info tab

      if (this.$route.path !== this.$route.fullPath) {
        this.$router.replace(this.$route.path); // clear the query
      }
    },
    breakShopCache() {
      // fetch data fresh from new endpoint and check updated_at of each object
      // business, workflows, blobs etc
      if (!this.business) return; // in case navigated away already, since this is delayed
      this.$store
        .dispatch("getBusinessAndWorkflowsBreakCache", this.businessID)
        .then((res) => {
          if (res.data) {
            console.log("break cache", res.data);
            var b = res.data;
            if (b.updated_at !== this.business.updated_at) {
              //// stale business
              // let oldTime = new Date(this.business.updated_at);
              // let newTime = new Date(b.updated_at);
              // this.sendDebugEmail(`Business updated! ${oldTime} vs ${newTime}`);
              this.infoToast("Business updated!");
              this.$store.commit("clearBusinesses");
              this.$store.commit("cacheBusiness", res.data); // caches  in state.businesses
              this.$store.commit("selectBusiness", this.businessID); // sets from cache
              this.onBusinessReady();
              return;
            }
            if (!b.workflows) return;
            var commerce = b.workflows.find((w) => w.name === "Commerce");
            if (!commerce || !this.commerce) return; // in case don't have commerce
            if (commerce.updated_at !== this.commerce.updated_at) {
              //// stale commerce workflow
              // let oldTime = new Date(this.commerce.updated_at);
              // let newTime = new Date(commerce.updated_at);
              // this.sendDebugEmail(`Commerce updated! ${oldTime} vs ${newTime}`);
              this.successToast("Shop updated!");
              this.$store.commit("clearBusinesses"); // stale business data, clear it all!
              this.$store.commit("cacheBusiness", res.data); // caches  in state.businesses
              this.$store.commit("selectBusiness", this.businessID); // sets from cache
              this.onBusinessReady();
            }
          }
        })
        .catch((err) => this.apiError(err));
      // this.$store.dispatch("getAndSelectBusiness", id).then(() => this.onBusinessReady()).catch((err) => this.apiError(err));
    },
    // sendDebugEmail(debug) {
    //   var obj = {
    //     type: "break_shop_cache",
    //     user_id: this.$store.state.user.id,
    //     uuid: this.$store.getters.getUUID,
    //     mobile: this.$store.getters.phoneNumber,
    //     name: this.$store.getters.realName,
    //     app: process.env.VUE_APP_TITLE,
    //     shop_name: this.businessName,
    //     fetched_at: this.business.fetched_at,
    //     app_version: this.$store.state.version,
    //     debug: debug,
    //     local_ts: new Date().toLocaleTimeString() + " BKK",
    //     ts: new Date(),
    //   };
    //   this.$store.dispatch("sendEmail", obj).catch((err) => console.error(err));
    // },
    doubleCheckIsShopOpen(id) {
      var isOpen = true;
      this.$store
        .dispatch("isShopOpenByID", id)
        .then((res) => {
          if (res.data === "yes") {
            console.log(`-- SHOP OPEN : ${res.data}`);
          } else {
            console.log(`-- NOT OPEN : ${res.data}`);
            isOpen = false;
          }
        })
        .catch((err) => {
          console.log(`-- OPEN ERR : NOT OPEN ??`, err);
          isOpen = false;
        })
        .finally(() => {
          if (this.isBlocked) return;
          if (this.isPaused && !isOpen) return;
          if (!this.isOpen && !isOpen) return;
          if (this.isOpen && isOpen) return;

          // if (isOpen && this.isOpen) return; // it seems ok
          // otherwise clear businesses cache and try again
          // var uuid = this.$store.getters.getUUID;
          // var msg = `Shop Not Open ❌ ${this.businessName} [ uuid: ${uuid} ]`;
          // this.sendSuperuserNotification(msg);

          var debug = `Shop Not Open ❌`;
          if (isOpen) debug = `Shop Open ⏰`;
          debug += ` isOpen: ${this.isOpen}, isPaused: ${this.isPaused}`;
          this.sendOldDebugEmail(debug);
          // this.$store.commit("clearBusinesses");
          // this.clearCacheAndReload();
        });
    },
    sendOldDebugEmail(debug) {
      var obj = {
        type: "is_shop_open_error",
        user_id: this.$store.state.user.id,
        uuid: this.$store.getters.getUUID,
        current_mobile: this.$store.getters.phoneNumber,
        name: this.$store.getters.realName,
        app: process.env.VUE_APP_TITLE,
        shop_name: this.businessName,
        fetched_at: this.business.fetched_at,
        app_version: this.$store.state.version,
        debug: debug,
        local_ts: new Date().toLocaleTimeString() + " BKK",
        ts: new Date(),
      };
      this.$store.dispatch("sendEmail", obj).catch((err) => console.error(err));
    },
    checkBusiness(id) {
      this.startLoadingTimer();
      this.$store.commit("selectBusiness", id); // try setting it
      // if (this.business) return this.onBusinessReady();
      // otherwise need to get it from API
      if (!id || id === "null") return this.goHome(); // sometimes mart would make null here
      this.$store
        .dispatch("getAndSelectBusiness", id)
        .then(() => this.onBusinessReady())
        .catch((err) => this.apiError(err));
    },
    checkTukLoader() {
      if (!this.isLoading) this.showTukLoader = false;
    },
    checkInactive() {
      if (
        this.business.is_deleted ||
        !this.isOpen ||
        this.isPaused ||
        this.isBlocked
      ) {
        this.showInactive = true;
      } else {
        this.showInactive = false;
      }
    },
    onBusinessReady() {
      this.checkInactive();
      this.checkCustomerBlacklist();
      this.checkHomeTab();
      this.showTukLoader = true;
      console.log("business ready", this.business);
      this.$store.commit("visitedShop", {
        key: this.business.name,
        value: this.business.id,
        pic: this.business.profile_pic_url,
      });
      if (this.business.is_deleted) {
        this.$store.commit("removeVisitedShop", this.business.id);
        if (!this.isSuperUser()) this.goHome();
        else {
          var msg = "Deleted business!<br>Redirects home for non-superusers";
          this.errorToast(msg, "bottom", 9000);
        }
      }
      this.z += 1;
      this.$nextTick(() => EventBus.$emit("SHOP_PROFILE_MAP"));
      this.populateBusinessData();
      this.isLoading = false;
      setTimeout(() => {
        if (this.isExpress) return;
        if (!this.isOpen) this.triggerShowHours(); // only show on load if not open
      }, 1000);
      this.doubleCheckMart();
      this.checkStyle();
    },
    checkStyle() {
      if (!this.commerce) return null;
      var m = this.commerce.data.menu_style;
      if (!m) return;
      // let query override default menu style
      console.log("checkStyle", this.query, m);
      if (this.query.menu_view) return;
      if (this.query.insta || this.query.instagram) return;
      // otherwise use
      if (m === "instagram") {
        this.instagram = true;
        this.menuView = "grid";
      }
      if (m === "grid") this.menuView = "grid";
      if (m === "list") this.menuView = "list";
    },
    doubleCheckMart() {
      // pull nearby marts, sort by distance and confirm this is really closest
      if (!this.business.data.categories) return;
      if (!this.business.data.categories.includes("_mart")) return; // not mart
      this.checkMart = true;
      this.updateMarts();
    },
    triggerShopWhenOpen() {
      var face = `<i class='far fa-clock'></i>&nbsp;`; // closed icon is clock
      var txt = this.$t("shop.place-order-when-open");
      var state = `<span style="font-weight:500">${txt}</span>`;
      var todaysHoursTxt = this.$t("shop.todays-hours");
      this.todaysHoursHTML = `${face} ${state}<p style='font-size:0.9em'>${todaysHoursTxt}: ${this.todaysHours}</p>`;
      this.showHours = true;
      setTimeout(() => (this.showHours = false), 5000);
    },
    triggerShowHours() {
      var face = `<i class='far fa-clock'></i>&nbsp;`; // closed icon is clock
      if (this.isOpen) face = `<i class='fa fa-smile'></i>&nbsp;`; // open icon is smiley face
      if (this.isPaused) face = `<i class="fa fa-hourglass-half"></i>&nbsp;`; // paused is hourglass
      if (this.isBlocked)
        face = `<i class="fa fa-exclamation-circle"></i>&nbsp;`;
      var todaysHours = this.$t("shop.todays-hours");
      var state = `<span style="font-weight:500; font-size:1.1em">${this.openClosed.text}</span>`;
      this.todaysHoursHTML = `${face} ${state}<p style='font-size:0.9em'>${todaysHours}: ${this.todaysHours}</p>`;
      this.showHours = true;
      setTimeout(() => (this.showHours = false), 5000);
    },
    shopStateToast() {
      var type = "error";
      var face = `<i class='far fa-clock'></i>&nbsp;`;
      if (this.isOpen) {
        face = `<i class='fa fa-smile'></i>&nbsp;`;
        type = "success";
      }
      var todaysHours = this.$t("shop.todays-hours");
      this.todaysHoursHTML = `${face} ${this.openClosed.text}<br>${todaysHours}: ${this.todaysHours}`;
      this.$toast.open({
        type: type,
        message: `${face} ${this.openClosed.text}<br>${todaysHours}: ${this.todaysHours}`,
        position: "top",
        duration: 3000,
      });
    },
    populateBusinessData() {
      var id = this.business.id;
      this.$store
        .dispatch("getWorkflows", id)
        .then(() => {
          setTimeout(() => this.getDeliveryWorkflows(), 1000);
          this.checkHomeTab();
        })
        .catch((err) => this.apiError(err));
      this.$store
        .dispatch("getShopPhotos", id)
        .catch((err) => this.apiError(err));
    },
    getDeliveryWorkflows() {
      if (!this.commerce) return; // skip if no commerce workflow
      // if (this.blockCustomerFromDelivery()) return; // skip if customer blocked from delivery
      this.deliveryWorkflows = null; // reset
      this.$store
        .dispatch("getCommerceDeliveryWorkflows", this.commerce.id)
        .then((res) => {
          console.log("getCommerceDeliveryWorkflows", res.data);
          if (res.data) {
            this.deliveryWorkflows = res.data; // { express: {}, fallback: {}}
            this.checkDeliveryWorkflows(); // check if delivery is available now
          }
        })
        .catch((err) => this.apiError(err));
    },
    blockCustomerFromDelivery() {
      if (!this.userDeliveryOptions) return;
      var opts = this.userDeliveryOptions;
      var nowTime = parseInt(this.hhmmTime());
      if (opts.start_time && nowTime < opts.start_time) return true;
      if (opts.end_time && nowTime && opts.end_time) return true;
      return false;
    },
    checkDeliveryWorkflows() {
      // check the main delivery workflow active or not
      // if (this.deliveryWorkflows.express.state === 'inactive')
      var express = this.deliveryWorkflows.express;
      if (express.state !== "inactive") return;
      var inactiveMaxDistance = express.data.inactive_max_distance;
      var maxDistance = Math.round(inactiveMaxDistance * 0.75);
      if (maxDistance >= 1000) {
        this.$swal({
          html: `<div style='text-align:left'>
        <p style='margin-bottom:12px; font-size:1.1em;'>
        <i class='fa fa-exclamation-triangle' style='color:cyan'></i>&nbsp;
        Limited Delivery Service
        &nbsp;<i class='fa fa-motorcycle' style='color:grey'></i>
        </p>
        <p style='margin-bottom:9px'>Due to weather/road conditions or holiday/festival traffic, delivery services are limited.</p>
        <p>Currently max delivery distance is <b>${maxDistance} meters</b>.</p>
        </div>`,
        });
      } else {
        this.$swal({
          html: `<div style='text-align:left'>
        <p style='margin-bottom:12px; font-size:1.1em;'>
        <i class='fa fa-exclamation-triangle' style='color:red'></i>&nbsp;
        Paused Delivery Service
        &nbsp;<i class='fa fa-motorcycle' style='color:grey'></i>
        </p>
        <p style='margin-bottom:9px'>Due to weather/road conditions or holiday/festival demand, delivery services are momentarily paused.</p>
        <p>We will re-open the delivery service for new orders as soon as conditions allow.</p>
        </div>`,
        });
      }
    },
    checkCustomerBlacklist() {
      if (!this.commerce) return;
      var blacklist = this.commerce.data.customer_blacklist;
      if (!blacklist || !blacklist.length) return;
      if (blacklist.includes(this.userID())) {
        this.$store.commit("removeVisitedShop", this.business.id);
        var msg = `Shop blacklist customer ❌ ${
          this.businessName
        } [user: ${this.userID()}]`;
        this.sendSuperuserNotification(msg);
        this.goHome(); // or go back
        this.errorToast("This shop is no longer available", "top");
      }
    },
    checkHomeTab() {
      if (this.homeTab) this.setTab(this.homeTab);
    },
    setTab(tab) {
      this.log("shop_tab", tab);
      this.shorten = false;
      if (tab === "promos" || tab === "menu") {
        if (this.$refs.menu) this.$refs.menu.reInit();
        if (!this.isSafari) this.triggerShopNameScroll();
        this.tab = "promos";
      } else if (tab === "info") {
        // EventBus.$emit("SHOP_INFO_TAB");
        // if (this.$refs.info) this.$refs.info.init();
        this.tab = "info";
      } else {
        this.infoToast(`${tab} is not a valid tab`);
        this.tab = "info"; // default tab
      }
      this.triggerProfilePicTransition();
    },
    triggerProfilePicTransition() {
      this.scrollTop = 1;
      setTimeout(() => (this.scrollTop = 0), 100);
    },
    viewBanner() {
      this.console("viewBanner", this.bannerPicURL);
      this.$el.querySelector(".banner").click();
      this.populateBusinessData(); // secret way to update menu and photos
    },
    favoriteShop() {
      if (!this.isFavorite(this.business.id)) {
        this.errorToast("Added to Favorites", "top");
      }
      this.$store.commit("favorite", this.business.id);
      this.log("favorite_shop", this.business.id);
    },
    shareShop() {
      this.log("share_shop");
      var url = this.hostURL() + `shop/${this.business.id}`;
      if (this.business.data.premium_link) {
        url = this.hostURL() + this.business.data.premium_link;
      } else if (this.business.data.normal_link) {
        url = this.hostURL() + this.business.data.normal_link;
      }
      if (!navigator.share) {
        console.log("native sharing not supported by this device");
        var blue = this.bulmaColor("link");
        this.$swal({
          // title: `<i class='fa fa-share-alt fa-lg' style='color:${blue}'></i>`,
          html: `<p style="font-size:1.2em"><i class='fa fa-share-alt' style='color:${blue}'></i>&nbsp;Share Link</p>
          <div style='margin-top:10px'><a href='${url}' target='_blank'>${url}</a></div>`,
          showCloseButton: true,
          confirmButtonText: "Copy to Clipboard <i class='fa fa-copy'></i>",
          confirmButtonColor: blue,
        }).then(() => this.$copyText(url));
        return;
      }
      var text = `Check out *${this.business.name}* on TUK App 🦜 !!`;
      navigator
        .share({ text: text, url: url })
        .catch((err) => console.log("Error sharing", err));
    },
    triggerShopNameScroll() {
      setTimeout(() => this.scrollLeft(9999), 1000);
      setTimeout(() => this.scrollLeft(0), 2000);
    },
    scrollLeft(pos) {
      if (!this.$refs.shopName) return;
      var options = { left: pos, behavior: "smooth" };
      this.$refs.shopName.scrollTo(options);
    },
  },
};
</script>

<style scoped>
.shop-profile {
  height: 100vh;
  overflow: hidden;
  /* background-color: black; */
}
.has-bg-img {
  background-color: gold;
  background-size: cover;
  background-position: center;
  /* height: 200px; */
  /* background-repeat: repeat-x; */
}
.tile {
  background-size: contain;
}
.open-closed {
  display: inline-block;
  background-color: rgba(255, 255, 255, 0.7);
  /* text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9); */
  text-shadow: 0 0 1px black, 0 0 2px white, 0 0 3px white, 0 0 3px white;
  font-weight: 500;
  border-bottom-left-radius: 8px;
  padding: 2px 4px;
  padding-top: 4px;
  position: relative;
  top: -6px;
  /* margin-left: 20px; */
  font-size: 1.1em;
  box-shadow: 0px 0px 1px black;
  /* background-color: #35ac5f;
  color: white; */
}
.top-right {
  position: absolute;
  right: 0px;
  top: 5px;
}
.gradient {
  padding-top: 14px;
  padding-bottom: 8px;
  background-image: linear-gradient(
    to bottom,
    transparent,
    rgba(0, 0, 0, 0.3) 20%,
    rgba(0, 0, 0, 0.8)
  );
}
.hero-wrapper {
  background-color: #333;
}
.hero {
  height: 200px;
  max-height: 200px;
  transition: max-height 0.2s ease;
  max-width: 700px;
  margin: auto;
}
.hero-short {
  /* height: 136px; */
  max-height: 100px;
  transition: max-height 0.2s ease;
}
.tab-name {
  position: absolute;
  top: 170px;
  /* right: max(calc((100vw - 900px) / 2), 0px); */
  right: 0;
  font-size: 0.8em;
  /* float: right; */
  padding: 8px;
  padding-top: 0;
  /* padding: 8px 16px; */
  transition: padding 0.3s ease;
  z-index: 3;
  color: white;
}
.tab-short {
  top: 70px !important;
}
@media only screen and (min-width: 850px) {
  .tab-name {
    /* right: calc((100vw - 900px) / 2); */
    right: initial;
    left: calc(700px + (100vw - 700px) / 2);
    top: 208px;
    color: #333 !important;
  }
  .tab-short {
    top: 108px !important;
  }
  .desktop-banner {
    height: 600px;
    width: initial;
    max-height: 50vh;
    background-size: cover;
    background-position: center;
    z-index: 0;
  }
}
.short-tabs .tab-name {
  padding: 0;
  transition: padding 0.3s ease;
}
.shadow {
  filter: drop-shadow(1px 1px 1px black);
}
.wiggle:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}
.loading {
  background-color: #fac002;
  width: 100vw;
  height: 100vh;
}
.dark.loading {
  background-color: #1f1b24;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.tuk-icon {
  background-image: url("../../public/img/icons/round-512x512.png");
  /* background-color: #cccccc; */
  position: absolute;
  /* height: min(50vw, 50vh);
  width: min(50vw, 50vh); */
  height: 150px;
  width: 150px;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire */
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
}
.fa-expand {
  position: absolute;
  right: 10px;
  opacity: 0.7;
}
.fa:active {
  font-size: 1.2em;
}
.hours-wrapper {
  text-align: center;
  position: absolute;
  top: 0px;
  /* left: 55px; */
  right: 0;
  /* height: 68px; */
  width: calc(100vw - 55px);
  max-width: 400px;
  margin: 0 auto;
  /* padding: 2px 6px 2px 12px; */
  padding: 0px 6px 0px 9px;
  background: linear-gradient(#ff386092, #ff3860);
  /* background: linear-gradient(#ff3860, #ff386092); */
  color: white;
  text-align: left;
  backdrop-filter: blur(2px);
  border-bottom-left-radius: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  border-left: 1px solid rgba(255, 255, 255, 0.5);
}
.superuser-edit {
  position: absolute;
  top: 80px;
  right: 0;
  z-index: 99999999;
  color: pink;
}
.is-open {
  /* background-color: #35ac5f; */
  background: linear-gradient(#35ac5fae, #35ac5f);
  /* background: linear-gradient(#35ac5f, #35ac5fae); */
}
.is-paused {
  background: linear-gradient(#ffdd57bb, #ffdd57);
  color: rgb(99, 99, 99);
}
.edit-btn {
  margin-top: -6px;
  margin-right: 15px;
  padding: 9px;
  /* background-color: rgba(0, 0, 0, 0.2); */
  background-color: rgba(105, 105, 105, 0.3);
}
.shop-name {
  position: relative;
  padding-left: 15px;
  z-index: 3;
}
.hero-short .shop-name {
  overflow: scroll;
  white-space: nowrap;
  max-width: calc(100% - 56px);
}
.hero-short .shop-name::-webkit-scrollbar {
  display: none;
}
.not-short {
  height: 50px;
}
.share {
  height: 22px;
  position: absolute;
  margin-top: 6px;
}
.deleted-bg {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.14);
}
.band-aid {
  padding: 12px;
  background-color: grey;
  color: white;
  width: 100vw;
  /* bottom: 50vh; */
  bottom: 200px;
  position: absolute;
  /* transform: translate(0%, -50%); */
  box-shadow: 1px 1px 5px black;
  font-size: 1.8em;
}
.band-aid.red {
  background-color: #ff3860;
  color: white;
}
.band-aid.yellow {
  background-color: #ffdd57;
  color: #444;
}
.band-aid.low {
  padding: 12px;
  background-color: lightskyblue;
}
.deleted-btn {
  padding: 12px;
  background-color: grey;
  color: white;
  /* margin: auto; */
  width: 50vw;
  top: 50vh;
  position: absolute;
  transform: translate(50%, -50%);
  border-radius: 100px;
  box-shadow: 1px 1px 5px black;
  font-size: 1.8em;
}
.inactive-btn {
  padding: 12px;
  background-color: lightskyblue;
  color: #444;
  left: 10vw;
  width: 80vw;
  /* top: 50vh; */
  bottom: 100px;
  position: absolute;
  transform: translate(0%, -50%);
  border-radius: 100px;
  box-shadow: 1px 1px 5px black;
  font-size: 1.8em;
}
.white-label {
  position: absolute;
  float: left;
  top: 0;
  left: 0;
  margin: 10px;
  padding: 5px 12.5px;
  z-index: 20;
  opacity: 0.9;
  box-shadow: 2px 2px 6px rgba(102, 102, 102, 0.7);
}
.banner {
  display: none;
}
.hidden-top-left-btn {
  position: absolute;
  top: 0;
  left: 65px;
  width: 80px;
  height: 60px;
}
.categories {
  position: relative;
  opacity: 0.8;
  max-width: calc(100% - 4px);
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 15px;
  padding-bottom: 20px;
  z-index: 2;
}
.profile-pic {
  position: absolute;
  top: 170px;
  /* left: 14px; */
  left: max(calc((100vw - 900px) / 2), 14px);
  border-radius: 3px;
  object-fit: cover;
  height: 75px;
  width: 75px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);
  z-index: 2;
  transition: all 0.9s ease;
}
.pp-high {
  transition: all 0.9s ease;
  top: 50px;
  /* left: 10px; */
  left: max(calc((100vw - 900px) / 2), 10px);
  border-radius: 100px;
  height: 66px;
  width: 66px;
  /* opacity: 0.8; */
}
.pp-medium {
  transition: all 0.9s ease;
  /* top: 94px; */
  top: 70px;
  /* left: 10px; */
  left: max(calc((100vw - 900px) / 2), 10px);
  border-radius: 10px;
  height: 66px;
  width: 66px;
}
.pp-hidden {
  transition: all 0.9s ease;
  top: -30px;
  left: 60px;
  border-radius: 100px;
  height: 30px;
  width: 30px;
}
.toggle-view {
  margin-right: 20px;
  color: white;
}
.toggle-right {
  transition: all 0.2s ease;
  /* margin-right: -5px; */
  margin-right: 9px;
}
/* .toggle-down-right {
  transition: all 0.2s ease;
  display: block;
  position: absolute;
  right: 10px;
} */
.share-right {
  position: absolute;
  right: 10px;
  top: 30px;
  border-radius: 30px;
}
.share-right img {
  height: 18px;
}
.desktop {
  height: 600px;
  max-height: 50vh;
  background-size: cover;
  background-position: center;
  z-index: 0;
}
.hide-top {
  visibility: hidden;
  height: calc(50vh + 60px);
  transition: all 3s ease;
}
.close-inactive {
  position: absolute;
  left: 0;
  margin-top: 10px;
  z-index: 9999;
  padding: 20px;
  background-color: green;
}
</style>